import { NgIf, NgClass } from '@angular/common';
import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { Util } from 'app/models/util';
import { QuillEditorComponent } from 'ngx-quill';

@Component({
    selector     : 'modal-edit-item-description',
    templateUrl  : './edit-item-description.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone   : true,
    imports      : [
        MatButtonModule, 
        MatIconModule, 
        FormsModule, 
        ReactiveFormsModule, 
        MatFormFieldModule, 
        MatInputModule, 
        NgIf, 
        NgClass,
        QuillEditorComponent
    ],
})
export class EditItemDescriptionComponent implements OnInit
{
    editItemDescriptionForm: UntypedFormGroup;
    quillModules: any = {
        toolbar: [
            ['bold', 'italic', 'underline'],
            [{align: []}, {list: 'ordered'}, {list: 'bullet'}],
            ['clean'],
        ],
    };

    /**
     * Constructor
     */
    constructor(
        public matDialogRef: MatDialogRef<EditItemDescriptionComponent>,
        private _formBuilder: UntypedFormBuilder,
        @Inject(MAT_DIALOG_DATA) public item: any,
        public util : Util,
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        // Create the form
        this.editItemDescriptionForm = this._formBuilder.group({
            description   : ['', [Validators.required]],
            itemName: [this.item ? this.item.name ? this.item.name : 'Untitled' : 'Unspecified'],
        });

        console.log('item', this.item);
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Save and close
     */
    saveAndClose(): void
    {
        // Get value, save item and close the dialog
        const itemDesc = this.editItemDescriptionForm.getRawValue();
        console.log(itemDesc);

        // Close the dialog
        this.matDialogRef.close();
    }

    /**
     * Discard the action
     */
    cancel(): void
    {
        // Close the dialog
        this.matDialogRef.close();
    }
  
}
